import http from '../../../app/services/httpServices';
import URL_UTILITY from '../../../app/utility/url.utility';

const uploadInvoiceDocumnet = (context, payload) => {
  return http.postApi(URL_UTILITY.uploadInvoiceDocumentUrl, payload);
};
const postInvoiceDetailsData = (context, payload) => {
  return http.postApi(URL_UTILITY.postInvoiceDocumentDataUrl + `/invoice-data`, payload);
};
const getInvoiceDetailsData = (context, payload) => {
  return http.getApi(URL_UTILITY.postInvoiceDocumentDataUrl + `/invoice-doc-data`, payload);
};
const getInvoiceDetailsDataById = (context, payload) => {
  return http.getApi(URL_UTILITY.postInvoiceDocumentDataUrl + `/invoice-data-by-hdr-id`, payload);
};
export default {
  uploadInvoiceDocumnet,
  postInvoiceDetailsData,
  getInvoiceDetailsData,
  getInvoiceDetailsDataById
};